import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBooleanGroupIntersect: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBooleanGroupIntersect"><Path d="M8.5 5.5V2.5H21.5V15.5H18.5M8.5 8.5V15.5H15.5" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 15.5V8.5H8.5M5.5 8.5H2.5V21.5H15.5V18.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBooleanGroupIntersect;
